/**
* @license lucide-solid v0.452.0 - ISC
*
* This source code is licensed under the ISC license.
* See the LICENSE file in the root directory of this source tree.
*/

// src/icons/laptop.tsx
import Icon from "../Icon";
var iconNode = [
  [
    "path",
    {
      d: "M20 16V7a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v9m16 0H4m16 0 1.28 2.55a1 1 0 0 1-.9 1.45H3.62a1 1 0 0 1-.9-1.45L4 16",
      key: "tarvll"
    }
  ]
];
var Laptop = (props) => <Icon {...props} name="Laptop" iconNode={iconNode} />;
var laptop_default = Laptop;
export {
  laptop_default as default
};
//# sourceMappingURL=laptop.jsx.map
